


























































import { Component, Vue, Prop } from "vue-property-decorator";
import CField from "@/components/form/CField.vue";
import { UsersListClass } from "@/classes/list/UsersListClass";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { accessApi } from "@/getinfo-api";
import { setAuthTokens } from "axios-jwt";
import { token } from "@/plugins/checkToken";

@Component({
  components: { CustomButton, CSingleSelect, CField }
})
export default class UserProfileView extends Vue {
  usersList: UsersListClass = new UsersListClass({});
  sharedAccess: any[] = [];
  myAccess: any[] = [];
  userId: undefined | string;
  backToken: any;
  showAddAccess: boolean = false;
  token: string = "";
  data() {
    return {
      userId: undefined,
      backToken: undefined
    };
  }

  shareAccess(userId: string | undefined = this.userId) {
    if (userId) {
      accessApi.Access.createAccess(userId).then(res => {
        this.getSharedAccess();
        this.showAddAccess = false;
      });
    }
  }

  removeAccess(id: string) {
    accessApi.Access.deleteAccess(id).then(() => {
      this.getSharedAccess();
    });
  }

  getAccess(id: string) {
    accessApi.Access.getToken(id).then(res => {
      localStorage.setItem("backToken", JSON.stringify(token.currentToken));

      setAuthTokens({
        accessToken: res.data.token,
        refreshToken: "fake-token"
      });
      localStorage.removeItem("selectedCompany");
      localStorage.removeItem("employee");
      localStorage.removeItem("ownerSelectedCompany");

      this.$router.push({ name: "userProfileView", params: { id: id } });
      location.reload();
    });
  }

  getSharedAccess() {
    accessApi.Access.listAccess().then(res => {
      this.sharedAccess = res.data.items;
    });
  }

  getMyAccess() {
    accessApi.Access.listAccessReverse().then(res => {
      this.myAccess = res.data.items;
    });
  }

  mounted() {
    this.getSharedAccess();
    this.getMyAccess();
  }
}
